import * as React from 'react';
import { ChangeEvent } from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { BranchSelectBox } from '../Form/BranchSelectBox';
import { FilterViewProps } from './FilterViewProps';

export class BranchFilter<T extends JobCenterModelInterface> extends React.PureComponent<FilterViewProps<T>> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: FilterViewProps<T>, context: any) {
        super(props, context);
        this.handleChange = this.handleChange.bind(this);
    }

    public render() {
        const props = this.props;

        return <BranchSelectBox valueId={props.filterSettings.branchId}
                                models={props.models}
                                placeholder={this.context.i18n.translate("Alle Filialen")}
                                onChange={this.handleChange}/>;
    }

    private handleChange(value: string | undefined, _event: ChangeEvent<HTMLSelectElement>) {
        const props = this.props;

        props.onChange(props.filterSettings.withBranchId(value));
    }
}
